module.exports = __webpack_public_path__ + "img/Group1.3abdadfb.png";